export function ThemeToggle({ id = "theme-toggle" } = {}) {
  return `
    <button
      id="${id}"
      type="button"
      class="inline-flex h-10 w-10 items-center justify-center rounded border border-white/20 text-white transition hover:border-accent hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-primary dark:border-border-dark dark:text-text-dark"
      aria-label="Toggle dark mode"
      aria-pressed="false"
      title="Toggle theme"
    >
      <svg class="theme-icon-sun h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 4V2M12 22v-2M4 12H2M22 12h-2M5 5 3.6 3.6M20.4 20.4 19 19M5 19l-1.4 1.4M20.4 3.6 19 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.8"/>
      </svg>
      <svg class="theme-icon-moon hidden h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M20 15.7A8.5 8.5 0 0 1 8.3 4a7 7 0 1 0 11.7 11.7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
      </svg>
    </button>
  `;
}

export function mountThemeToggle(root = document) {
  const buttons = root.querySelectorAll("[data-theme-toggle]");
  const targets = buttons.length ? buttons : root.querySelectorAll("#theme-toggle, #theme-toggle-mobile");
  if (!targets.length) return;

  const applyIconState = () => {
    const isDark = document.documentElement.classList.contains("dark");
    targets.forEach((button) => {
      button.setAttribute("aria-pressed", String(isDark));
      button.querySelector(".theme-icon-sun")?.classList.toggle("hidden", isDark);
      button.querySelector(".theme-icon-moon")?.classList.toggle("hidden", !isDark);
    });
  };

  applyIconState();

  targets.forEach((button) => {
    button.dataset.themeToggle = "true";
    button.addEventListener("click", () => {
      const isDark = document.documentElement.classList.toggle("dark");
      localStorage.setItem("theme", isDark ? "dark" : "light");
      applyIconState();
    });
  });
}
